export const Marquee = ({ items, dark = false, className = "" }) => (
  <div
    className={`overflow-hidden border-y py-4 ${
      dark ? "border-sand/10 bg-night" : "border-ink/10 bg-cream/60"
    } ${className}`}
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((t, i) => (
            <span
              key={i}
              className={`flex items-center font-display text-xs font-bold uppercase tracking-[0.35em] sm:text-sm ${
                dark ? "text-sand/40" : "text-ink/45"
              }`}
            >
              <span className="px-6 sm:px-8">{t}</span>
              <span className="text-gold">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
